/*eslint-disable */
import xlsx from 'xlsx'
import {db} from '@/firebase'
import moment from 'moment'

function getTimestamp() {
  const d = new Date()
  let t = String(d.getFullYear()) + String((d.getMonth()+1)) + String(d.getDate()) + String(d.getHours()) + String(d.getMinutes()) + String(d.getSeconds())
  return t
}

async function exportIntentListXlsx(data, startDate, endDate) {
  let listOfIntentName = []
  let listOfTotalIntent = []
  const msgs = []
  const totalMsgs = []
  let totalNumber = 0
  let numberUnmatch = 0
  let totalTopics = {}
  Object.entries(data).forEach(function([key, val]) {
    const dailyDatas = Object.values(val)
    Object.entries(dailyDatas[0]).forEach(([intentName, intentData]) => {
      if (!totalTopics[intentName]) {
        totalTopics[intentName] = {
          interactions: 0,
        }
      }
      totalTopics[intentName].interactions += intentData.interactions || 0
      if (intentName == 'Default Fallback Intent') {
        numberUnmatch += intentData.interactions
      }
      totalNumber += intentData.interactions || 0
    })
  })
  Object.entries(totalTopics).forEach(([intentName, intentData]) => {
    if (intentData.interactions != 0) {
      listOfIntentName.push(intentName)
      intentData.interactions = intentData.interactions || 0
      listOfTotalIntent.push(intentData.interactions)
    }
  })
  var keysSorted = []
  for (var i = 0; i < listOfTotalIntent.length; i++) {
    keysSorted.push(i) // add index to output array
  }
  keysSorted.sort(function(a, b) { return listOfTotalIntent[b] - listOfTotalIntent[a] })
  let topListOfTotalIntent = []
  let topListOfIntentName = []
  let category = ''
  for (let i = 0; i < listOfTotalIntent.length; i += 1) {
    topListOfTotalIntent.push(listOfTotalIntent[keysSorted[i]])
    topListOfIntentName.push(listOfIntentName[keysSorted[i]])
    if (listOfIntentName[keysSorted[i]].includes('Small') || listOfIntentName[keysSorted[i]].includes('ST0')) {
      category = 'Small Talks'
    } else if (listOfIntentName[keysSorted[i]].includes('i10')) {
      category = 'General Info'
    } else if (listOfIntentName[keysSorted[i]].includes('i11')) {
      category = 'Cust Service'
    } else if (listOfIntentName[keysSorted[i]].includes('i12')) {
      category = 'Getting There'
    } else if (listOfIntentName[keysSorted[i]].includes('i20')) {
      category = 'Room'
    } else if (listOfIntentName[keysSorted[i]].includes('i21')) {
      category = 'Reservations'
    } else if (listOfIntentName[keysSorted[i]].includes('i22')) {
      category = 'Booking'
    } else if (listOfIntentName[keysSorted[i]].includes('i23')) {
      category = 'Membership'
    } else if (listOfIntentName[keysSorted[i]].includes('i31')) {
      category = 'Casino'
    } else if (listOfIntentName[keysSorted[i]].includes('i32')) {
      category = 'Concert'
    } else if (listOfIntentName[keysSorted[i]].includes('i33')) {
      category = 'Attractions'
    } else if (listOfIntentName[keysSorted[i]].includes('i34')) {
      category = 'Dining'
    } else {
      category = 'Others'
    }
    msgs.push({
      name: listOfIntentName[keysSorted[i]],
      number: listOfTotalIntent[keysSorted[i]],
      category,
      percent: `${(listOfTotalIntent[keysSorted[i]] / totalNumber * 100).toFixed(1)}%`,
    })
  }
  totalMsgs.push({
    name: 'Total Intents',
    number: totalNumber,
    percent: `100%`,
    _rowVariant: 'success',
  })
  totalMsgs.push({
    name: 'Total Matched',
    number: totalNumber - numberUnmatch,
    percent: `${((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
    _rowVariant: 'warning',
  })
  totalMsgs.push({
    name: 'Total Unmatched',
    number: numberUnmatch,
    percent: `${((numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
    _rowVariant: 'danger',
  })
  self.totalTableItems = totalMsgs

  let ws = xlsx.utils.json_to_sheet([{A: 'Date Range', B: startDate, C: endDate, D: ''}],
    {header: ['A', 'B', 'C', 'D'], skipHeader: true})
  xlsx.utils.sheet_add_json(ws, [{A: '', B: '', C: '', D: ''}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  xlsx.utils.sheet_add_json(ws, [{A: 'Total', B: 'Category', C: 'Number', D: 'Percent'}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  for (let i = 0; i < totalMsgs.length; i += 1) {
    xlsx.utils.sheet_add_json(ws, [{A: totalMsgs[i].name, B: totalMsgs[i].category, C: totalMsgs[i].number, D: totalMsgs[i].percent}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  }
  xlsx.utils.sheet_add_json(ws, [{A: '', B: '', C: '', D: ''}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  xlsx.utils.sheet_add_json(ws, [{A: 'Name of Intent', B: 'Category', C: 'Number', D: 'Percent'}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  for (let i = 0; i < msgs.length; i += 1) {
    xlsx.utils.sheet_add_json(ws, [{A: msgs[i].name, B: msgs[i].category, C: msgs[i].number, D: msgs[i].percent}], { header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1 })
  }
  let wb = { SheetNames: [], Sheets: {} }
  wb.SheetNames.push('Intents List')
  wb.Sheets['Intents List'] = ws
  const d = getTimestamp()
  xlsx.writeFile(wb, `IntentList_${d}.xlsx`)
}

function exportIntentListPDF(data, startDate, endDate) {
  let listOfIntentName = []
  let listOfTotalIntent = []
  const msgs = []
  const totalMsgs = []
  let totalNumber = 0
  let numberUnmatch = 0
  let totalTopics = {}
  Object.entries(data).forEach(function([key, val]) {
    const dailyDatas = Object.values(val)
    Object.entries(dailyDatas[0]).forEach(([intentName, intentData]) => {
      if (!totalTopics[intentName]) {
        totalTopics[intentName] = {
          interactions: 0,
        }
      }
      totalTopics[intentName].interactions += intentData.interactions || 0
      if (intentName == 'Default Fallback Intent') {
        numberUnmatch += intentData.interactions
      }
      totalNumber += intentData.interactions || 0
    })
  })
  Object.entries(totalTopics).forEach(([intentName, intentData]) => {
    if (intentData.interactions != 0) {
      listOfIntentName.push(intentName)
      intentData.interactions = intentData.interactions || 0
      listOfTotalIntent.push(intentData.interactions)
    }
  })
  var keysSorted = []
  for (var i = 0; i < listOfTotalIntent.length; i++) {
    keysSorted.push(i) // add index to output array
  }
  keysSorted.sort(function(a, b) { return listOfTotalIntent[b] - listOfTotalIntent[a] })
  let topListOfTotalIntent = []
  let topListOfIntentName = []
  let category = ''
  for (let i = 0; i < listOfTotalIntent.length; i += 1) {
    topListOfTotalIntent.push(listOfTotalIntent[keysSorted[i]])
    topListOfIntentName.push(listOfIntentName[keysSorted[i]])
    if (listOfIntentName[keysSorted[i]].includes('Small') || listOfIntentName[keysSorted[i]].includes('ST0')) {
      category = 'Small Talks'
    } else if (listOfIntentName[keysSorted[i]].includes('i10')) {
      category = 'General Info'
    } else if (listOfIntentName[keysSorted[i]].includes('i11')) {
      category = 'Cust Service'
    } else if (listOfIntentName[keysSorted[i]].includes('i12')) {
      category = 'Getting There'
    } else if (listOfIntentName[keysSorted[i]].includes('i20')) {
      category = 'Room'
    } else if (listOfIntentName[keysSorted[i]].includes('i21')) {
      category = 'Reservations'
    } else if (listOfIntentName[keysSorted[i]].includes('i22')) {
      category = 'Booking'
    } else if (listOfIntentName[keysSorted[i]].includes('i23')) {
      category = 'Membership'
    } else if (listOfIntentName[keysSorted[i]].includes('i31')) {
      category = 'Casino'
    } else if (listOfIntentName[keysSorted[i]].includes('i32')) {
      category = 'Concert'
    } else if (listOfIntentName[keysSorted[i]].includes('i33')) {
      category = 'Attractions'
    } else if (listOfIntentName[keysSorted[i]].includes('i34')) {
      category = 'Dining'
    } else {
      category = 'Others'
    }
    msgs.push({
      name: listOfIntentName[keysSorted[i]],
      number: listOfTotalIntent[keysSorted[i]],
      category,
      percent: `${(listOfTotalIntent[keysSorted[i]] / totalNumber * 100).toFixed(1)}%`,
    })
  }
  totalMsgs.push({
    name: 'Total Intents',
    number: totalNumber,
    percent: `100%`,
    _rowVariant: 'success',
  })
  totalMsgs.push({
    name: 'Total Matched',
    number: totalNumber - numberUnmatch,
    percent: `${((totalNumber - numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
    _rowVariant: 'warning',
  })
  totalMsgs.push({
    name: 'Total Unmatched',
    number: numberUnmatch,
    percent: `${((numberUnmatch) / totalNumber * 100).toFixed(1)}%`,
    _rowVariant: 'danger',
  })

  let pdf = new Jspdf('p', 'pt')
  const totalColumns = [
    { title: 'Total', dataKey: 'total' },
    { title: 'Category', dataKey: 'category' },
    { title: 'Number', dataKey: 'number' },
    { title: 'Percent', dataKey: 'percent' },
  ]
  const intentColumns = [
    { title: 'Name of Intent', dataKey: 'name' },
    { title: 'Category', dataKey: 'category' },
    { title: 'Number', dataKey: 'number' },
    { title: 'Percent', dataKey: 'percent' },
  ]
  const titleRows = []
  const intentRows = []
  pdf.text('Intents List', 260, 40)
  pdf.setFontSize(12)
  pdf.text(`${startDate} - ${endDate}`, 230, 60)

  // push the data into the pdf rows
  for (let i = 0; i < totalMsgs.length; i += 1) {
    titleRows.push({total: totalMsgs[i].name, category: totalMsgs[i].category, number: totalMsgs[i].number, percent: totalMsgs[i].percent})
  }
  for (let i = 0; i < msgs.length; i += 1) {
    intentRows.push({name: msgs[i].name, category: msgs[i].category, number: msgs[i].number, percent: msgs[i].percent})
  }
  const d = getTimestamp()
  pdf.autoTable(totalColumns, titleRows, {
    margin: { top: 75 },
    styles: { overflow: 'linebreak' },
    columnStyles: {
      total: {
        overflow: 'linebreak',
        cellWidth: 250,
      },
      category: {
        cellWidth: 70,
      },
      number: {
        cellWidth: 70,
      },
      percent: {
        cellWidth: 70,
      },
    },
  })
  pdf.autoTable(intentColumns, intentRows, {
    columnStyles: {
      name: {
        overflow: 'linebreak',
        cellWidth: 250,
      },
      category: {
        cellWidth: 70,
      },
      number: {
        cellWidth: 70,
      },
      percent: {
        cellWidth: 70,
      },
    },
  })
  pdf.save(`IntentList_${d}.pdf`)
}

/* function exportMessages(data) {
  let ws = xlsx.utils.json_to_sheet([{A: 'Message from', B: 'Message', C: 'Platform', D: 'Score', E: 'Timestamp'}],
    {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true})
  db.ref(`chats/${data}/chats`).once('value').then((datasnapshot) => {
    datasnapshot.forEach(function(child) {
      let messageFrom // user, agent or bot
      if (child.val().fromUser == true) {
        messageFrom = 'User'
      } else if (child.val().matchedIntent == 'N/A from Dashboard') {
        messageFrom = 'Live Chat Agent'
      } else {
        messageFrom = 'Chat Bot'
      }
      let cutOff = 99999 // CC hack, to prevent code not working if changed
      let message
      if (typeof child.val().message === 'string') {
        message = child.val().message
      } else if (child.val().message[0].speech) {
        message = child.val().message[0].speech.slice(0, cutOff) + ((child.val().message[0].speech.length > cutOff) ? '...' : '')
      } else if (child.val().message[0].text) {
        message = child.val().message[0].text.text[0].slice(0, cutOff) + ((child.val().message[0].text.text[0].length > cutOff) ? '...' : '')
      } else if (child.val().message[0].quickReplies) {
        message = child.val().message[0].quickReplies.title.slice(0, cutOff) + ((child.val().message[0].quickReplies.title.length > cutOff) ? '...' : '')
      } else {
        message = '...'
      }
      let platform = child.val().platform.source
      let score = child.val().score
      let timestamp = child.val().timestamp
      xlsx.utils.sheet_add_json(ws, [{A: messageFrom, B: message, C: platform, D: score, E: timestamp}],
        {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true, origin: -1})
    })
  })
}

function exportAllMessage() {
  db.ref(`chats`).once('value').then((datasnapshot) => {
    datasnapshot.forEach(function(child) {
      let ws = xlsx.utils.json_to_sheet([{A: 'Message from', B: 'Message', C: 'Platform', D: 'Score', E: 'Timestamp'}],
        {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true})
      child.val().chats.forEach(function(child) {
        let messageFrom // user, agent or bot
        if (child.val().fromUser == true) {
          messageFrom = 'User'
        } else if (child.val().matchedIntent == 'N/A from Dashboard') {
          messageFrom = 'Live Chat Agent'
        } else {
          messageFrom = 'Chat Bot'
        }
        let cutOff = 99999 // CC hack, to prevent code not working if changed
        let message
        if (typeof child.val().message === 'string') {
          message = child.val().message
        } else if (child.val().message[0].speech) {
          message = child.val().message[0].speech.slice(0, cutOff) + ((child.val().message[0].speech.length > cutOff) ? '...' : '')
        } else if (child.val().message[0].text) {
          message = child.val().message[0].text.text[0].slice(0, cutOff) + ((child.val().message[0].text.text[0].length > cutOff) ? '...' : '')
        } else if (child.val().message[0].quickReplies) {
          message = child.val().message[0].quickReplies.title.slice(0, cutOff) + ((child.val().message[0].quickReplies.title.length > cutOff) ? '...' : '')
        } else {
          message = '...'
        }
        let platform = child.val().platform.source
        let score = child.val().score
        let timestamp = child.val().timestamp
        xlsx.utils.sheet_add_json(ws, [{A: messageFrom, B: message, C: platform, D: score, E: timestamp}],
          {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true, origin: -1})
      })
    })
  })
} */

function exportCustomer() {
  db.ref(`users`).once('value').then((datasnapshot) => {
    let ws = xlsx.utils.json_to_sheet([{A: 'Customer Name/ ID', B: 'Email', C: 'Phone Number', D: 'Last Interaction'}],
      {header: ['A', 'B', 'C', 'D'], skipHeader: true})
    let k = Object.keys(datasnapshot.val())
    for (let i = k.length - 1; i >= 0; i--){
      const key = k[i]
      let name
      if (datasnapshot.val()[key].hasOwnProperty('firstName')) {
        name = `${datasnapshot.val()[key].firstName} ${datasnapshot.val()[key].lastName}`
      } else {
        name = key
      }
      let email = datasnapshot.val()[key].email || 'Not Applicable'
      let ph = datasnapshot.val()[key].telNo || 'Not Applicable'
      let ts = datasnapshot.val()[key].timestamp ? moment(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA") : moment().format("Do MMM 'YY, hh:mmA")
      xlsx.utils.sheet_add_json(ws, [{A: name, B: email, C: ph, D: ts}],
        {header: ['A', 'B', 'C', 'D'], skipHeader: true, origin: -1})
    }
    /* Object.entries(datasnapshot.val()).forEach(function([key, val]) {
      let name
      if (val.hasOwnProperty('firstName')) {
        name = `${val.firstName} ${val.lastName}`
      } else {
        name = key
      }
      let fb = val.fb || 'Not Applicable'
      let pn = val.phoneNumber || 'Not Applicable'
      let tz = val.timezone || 'Not Applicable'
      let language = val.locale || 'Not Applicable'
      xlsx.utils.sheet_add_json(ws, [{A: name, B: fb, C: pn, D: tz, E: language}],
        {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true, origin: -1})
    }) */
    let wb = { SheetNames: [], Sheets: {} }
    wb.SheetNames.push('Customer')
    wb.Sheets['Customer'] = ws
    const d = getTimestamp()
    xlsx.writeFile(wb, `imSME_ChatBot_CustomerData_${d}.xlsx`)
  })
}

function exportCustomerPDF() {
  db.ref(`users`).once('value').then((datasnapshot) => {
    let pdf = new jspdf('p', 'pt')
    let columns = [
    {title: 'Customer Name/ ID', dataKey: 'Name'},
    {title: 'Email', dataKey: 'Email'},
    {title: 'Phone Number', dataKey: 'PhoneNumber'},
    {title: 'Last Interaction', dataKey: 'Timezone'},
  ];
  let rows = []
  pdf.text('Customer Data', 250, 40)
  let k = Object.keys(datasnapshot.val())
    for (let i = k.length - 1; i >= 0; i--){
      const key = k[i]
      let name
      if (datasnapshot.val()[key].hasOwnProperty('firstName')) {
        name = `${datasnapshot.val()[key].firstName} ${datasnapshot.val()[key].lastName}`
      } else {
        name = key
      }
      let email = datasnapshot.val()[key].email || 'Not Applicable'
      let ph = datasnapshot.val()[key].telNo || 'Not Applicable'
      let ts = datasnapshot.val()[key].timestamp ? moment(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA") : moment().format("Do MMM 'YY, hh:mmA")
      rows.push({Name: name, Email: email, PhoneNumber: ph, Timezone: ts})
    }
    /* Object.entries(datasnapshot.val()).forEach(function([key, val]) {
      let name
      if (val.hasOwnProperty('firstName')) {
        name = `${val.firstName} ${val.lastName}`
      } else {
        name = key
      }
      let fb = val.fb || 'Not Applicable'
      let pn = val.phoneNumber || 'Not Applicable'
      let tz = val.timezone || 'Not Applicable'
      let language = val.locale || 'Not Applicable'
      rows.push({Name: name, FacebookMessengerID: fb, PhoneNumber: pn, Timezone: tz, Language: language})
    }) */
    const d = getTimestamp()
    pdf.autoTable(columns, rows, {margin: {top: 70}})
    pdf.save(`imSME_ChatBot_CustomerData_${d}.pdf`)
  })
}

function exportCRM() {
  db.ref('custom/appt').once('value').then((datasnapshot) => {
    let ws = xlsx.utils.json_to_sheet([{A: 'Customer Name', B: 'E-mail', C: 'Phone Number', D: 'Submitted On', E: 'Resolved', F: 'Remark'}],
      {header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true})
    let k = Object.keys(datasnapshot.val())
    for (let i = k.length - 1; i >= 0; i--){
      const key = k[i]
      let name = datasnapshot.val()[key].fullName || 'Not Applicable'
      let email = datasnapshot.val()[key].email || 'Not Applicable'
      let ph = datasnapshot.val()[key].telNo || 'Not Applicable'
      let ts = moment(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA")
      let resolved = datasnapshot.val()[key].resolved ? 'Done' : 'Undone'
      let remark = datasnapshot.val()[key].remark || 'Not Applicable'
      xlsx.utils.sheet_add_json(ws, [{A: name, B: email, C: ph, D: ts, E: resolved, F: remark}],
        {header: ['A', 'B', 'C', 'D', 'E', 'F'], skipHeader: true, origin: -1})
    }
    /* Object.entries(datasnapshot.val()).forEach(function([key, val]) {
      let name = val.fullName
      let email = val.email
      let ph = val.telNo || 'Not Applicable'
      let ts = moment(parseInt(val.timestamp)).format("Do MMM 'YY, hh:mmA")
      let resolved = val.resolved || false
      xlsx.utils.sheet_add_json(ws, [{A: name, B: email, C: ph, D: ts, E: resolved}],
        {header: ['A', 'B', 'C', 'D', 'E'], skipHeader: true, origin: -1})
    }) */
    let wb = { SheetNames: [], Sheets: {} }
    wb.SheetNames.push('CRM')
    wb.Sheets['CRM'] = ws
    const d = getTimestamp()
    xlsx.writeFile(wb, `imSME_ChatBot_CRM_${d}.xlsx`)
  })
}

function exportCRMPDF() {
  db.ref('custom/appt').once('value').then((datasnapshot) => {
    let pdf = new jspdf('l', 'pt')
    let columns = [
    {title: 'Customer Name', dataKey: 'CustomerName'},
    {title: 'E-mail', dataKey: 'email'},
    {title: 'Phone Number', dataKey: 'PhoneNumber'},
    {title: 'Submitted On', dataKey: 'Timestamp'},
    {title: 'Resolved', dataKey: 'Resolved'},
    {title: 'Remark', dataKey: 'Remark'}
  ];
  let rows = []
  pdf.text('Customer Relationship Management', 300, 40)
  let k = Object.keys(datasnapshot.val())
    for (let i = k.length - 1; i >= 0; i--){
      const key = k[i]
      let name = datasnapshot.val()[key].fullName || 'Not Applicable'
      let email = datasnapshot.val()[key].email || 'Not Applicable'
      let ph = datasnapshot.val()[key].telNo || 'Not Applicable'
      let ts = moment(parseInt(datasnapshot.val()[key].timestamp)).format("Do MMM 'YY, hh:mmA")
      let resolved = datasnapshot.val()[key].resolved ? 'Done' : 'Undone'
      let remark = datasnapshot.val()[key].remark || 'Not Applicable'
      rows.push({CustomerName: name, email: email, PhoneNumber: ph, Timestamp: ts, Resolved: resolved, Remark: remark})
    }
    /* Object.entries(datasnapshot.val()).forEach(function([key, val]) {
      let name = val.fullName
      let email = val.email
      let ph = val.telNo
      let ts = val.timestamp
      let resolved = val.resolved || false
      rows.push({CustomerName: name, email: email, PhoneNumber: ph, Timestamp: ts, Resolved: resolved})
    }) */
    const d = getTimestamp()
    pdf.autoTable(columns, rows, {margin: {top: 70}})
    pdf.save(`imSME_ChatBot_CRM_${d}.pdf`)
  })
}

function exportIntent() {
  db.ref('analytics/topics').once('value').then((datasnapshot) => {
    let ws = xlsx.utils.json_to_sheet([{A: 'Topics', B: 'Users Count', C: 'Interactions Count'}],
      {header: ['A', 'B', 'C'], skipHeader: true})
    datasnapshot.forEach(function(child) {
      xlsx.utils.sheet_add_json(ws, [{A: child.val().intent, B: child.val().interactions, C: child.val().users}],
        {header: ['A', 'B', 'C'], skipHeader: true, origin: -1})
    })
    let wb = { SheetNames: [], Sheets: {} }
    wb.SheetNames.push('Intent')
    wb.Sheets['Intent'] = ws
    const d = getTimestamp()
    xlsx.writeFile(wb, `imSME_ChatBot_Intent_${d}.xlsx`)
  })
}

function exportIntentPDF() {
  db.ref('analytics/topics').once('value').then((datasnapshot) => {
    let pdf = new jspdf('p', 'pt')
    let columns = [
    {title: 'Topics', dataKey: 'Intent'},
    {title: 'Users Count', dataKey: 'Interaction'},
    {title: 'Interactions Count', dataKey: 'Users'},
  ];
  let rows = []
  pdf.text('Intent List', 275, 40)
    datasnapshot.forEach(function(child) {
      rows.push({Intent: child.val().intent, Interaction: child.val().interactions, Users: child.val().users})
    })
    const d = getTimestamp()
    pdf.autoTable(columns, rows, {margin: {top: 70}})
    pdf.save(`imSME_ChatBot_Intent_${d}.pdf`)
  })
}

// export const ems = exportMessages
// export const eam = exportAllMessage
export const ec = exportCustomer
export const ecp = exportCustomerPDF
export const ecrm = exportCRM
export const ecrmp = exportCRMPDF
export const ei = exportIntent
export const eip = exportIntentPDF
export const exportIntentListExcel = exportIntentListXlsx
export const exportIntentListPdf = exportIntentListPDF




// WEBPACK FOOTER //
// ./src/jsonToXlsx.js